module.exports = __webpack_public_path__ + "img/1480133803.20d5afb2.jpg";